import { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { TemplateFormPage } from "../layout/templateForm";

import { MY_AVD_HERO, MY_AVD_REMOVE_PATH, MY_AVD_SETUP_PATH } from "./avdEntitlement";

const BACK = { href: "/my-avd", label: "Back to My AVD" };
// `<Routes>` under the page's `/my-avd/*` mount wants the segment after it.
const segment = (path: string) => path.slice("/my-avd/".length);

/** My AVD and its two forms; anything else under it goes back to the page. */
export function AvdRoutes(props: Readonly<{ page: ReactNode }>): ReactNode {
	return (
		<Routes>
			<Route path="/" element={props.page} />
			<Route
				path={segment(MY_AVD_SETUP_PATH)}
				element={
					<TemplateFormPage
						eyebrow={MY_AVD_HERO.eyebrow}
						title="Set up my desktop."
						templateName="provision-avd"
						back={BACK}
					/>
				}
			/>
			<Route
				path={segment(MY_AVD_REMOVE_PATH)}
				element={
					<TemplateFormPage
						eyebrow={MY_AVD_HERO.eyebrow}
						title="Remove my desktop."
						templateName="deprovision-avd"
						back={BACK}
					/>
				}
			/>
			<Route path="*" element={<Navigate to={BACK.href} replace />} />
		</Routes>
	);
}
